import { Box, Stack } from "@mui/material";
import React from "react";
import RectangleSkeletons from "../RectangleSkeletons";

const Skeleton98977 = () => {
  return (
    <Stack
      gap="24px"
      border="1px solid #EBEBEB"
      borderRadius="8px"
      height="100%"
    >
      <Stack padding="16px">
        <RectangleSkeletons totalRows={1} height={42} />
      </Stack>

      {Array(3)
        .fill()
        .map((_, index) => (
          <Box
            padding="16px"
            display="flex"
            alignItems="flex-start"
            gap="24px"
            key={index}
          >
            <RectangleSkeletons totalRows={1} height={52} width={28} />
            <Stack width="100%" gap="4px">
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                width="100%"
                gap="8px"
              >
                <RectangleSkeletons
                  component="div"
                  width={172}
                  totalRows={1}
                  height={19}
                />
                <Stack width={68}>
                  <RectangleSkeletons totalRows={1} height={19} />
                </Stack>
              </Box>
              <Stack gap="8px" width="100%">
                <RectangleSkeletons totalRows={1} height={19} />
                <RectangleSkeletons totalRows={1} height={48} />
              </Stack>
            </Stack>
          </Box>
        ))}
    </Stack>
  );
};

export default Skeleton98977;
